import React from 'react';
import { Label } from '@commonsku/styles';
import styled from 'styled-components';
import { CurrencyToggleProps } from './types';

const CurrencyToggleContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 100px;
`;

const CurrencyOptionsRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
`;

const CurrencyIconButton = styled.button.attrs({ type: 'button' })<{ $selected?: boolean; $first?: boolean }>`
  && {
    width: 34px;
    height: 34px;
    border-radius: 20px;
    padding: ${({ $selected }) => ($selected ? '0px' : '3px')};
    line-height: 1.5rem;
    cursor: pointer;
    background: ${({ $selected }) => ($selected ? '#FFFFFF' : '#E1F7FA')};
    mix-blend-mode: normal;
    margin-right: ${({ $first }) => ($first ? '5px' : '0')};
    border: ${({ $selected }) => ($selected ? '3px solid #00A0B6' : 'none')};
  }
`;

const CurrencyIconWrapper = styled.div<{ $selected?: boolean }>`
  opacity: ${({ $selected }) => ($selected ? 1 : 0.4)};
`;

const CurrencyToggle: React.FC<CurrencyToggleProps> = ({ options, onToggle }) => {
  return (
    <CurrencyToggleContainer>
      <Label>Currency</Label>
      <CurrencyOptionsRow>
        {options.map((option, index) => (
          <CurrencyIconButton
            key={option.value}
            $selected={option.isRefined}
            $first={index === 0}
            onClick={() => onToggle(option.value)}
          >
            <CurrencyIconWrapper $selected={option.isRefined}>
              <img src={option.iconSrc} alt={option.value} />
            </CurrencyIconWrapper>
          </CurrencyIconButton>
        ))}
      </CurrencyOptionsRow>
    </CurrencyToggleContainer>
  );
};

export default CurrencyToggle;
